"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.clonedeep")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _utils = require("../utils"),
    _CollaborationContext = require("../contexts/CollaborationContext"),
    _CollaborationModal = _interopRequireDefault(require("./CollaborationModal")),
    _ShareModal = _interopRequireDefault(require("./ShareModal")),
    _constants = require("../constants");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var CollaborationProvider = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.getProviderValue = (0, _memoizeOne["default"])(function (a, b) {
      return {
        showCollaborationModal: d.showCollaborationModal,
        hideCollaborationModal: d.hideCollaborationModal,
        showShareModal: d.showShareModal,
        hideShareModal: d.hideShareModal,
        fetchCollaborationData: d.fetchCollaborationData,
        resourceName: b,
        members: a
      };
    }), d.fetchResourceRoles = function () {
      var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
        var c, e, f, g, h, i, j, k, l;
        return _regenerator["default"].wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                return c = d.props.getResourceRoles, a.next = 3, c(b);

              case 3:
                if (e = a.sent, f = e.data, f = void 0 === f ? {} : f, g = f.getRoles, h = void 0 === g ? [] : g, i = e.error, !i) {
                  a.next = 9;
                  break;
                }

                return a.abrupt("return", {
                  error: i
                });

              case 9:
                return j = h.map(function (a) {
                  return _objectSpread(_objectSpread({}, a), {}, {
                    description: _constants.ROLE_MAP[a.name]
                  });
                }), k = j.find(function (a) {
                  var b = a.name;
                  return "GUEST" === b;
                }), l = j.find(function (a) {
                  var b = a.name;
                  return "NONE" === b;
                }), a.abrupt("return", {
                  roles: j,
                  guestRole: k,
                  noneRole: l
                });

              case 13:
              case "end":
                return a.stop();
            }
          }
        }, a);
      }));
      return function () {
        return a.apply(this, arguments);
      };
    }(), d.fetchRoleAssignments = function () {
      var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
        var c, e, f, g, h, i;
        return _regenerator["default"].wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                return c = d.props.getRoleAssignments, a.next = 3, c(b);

              case 3:
                if (e = a.sent, f = e.data, f = void 0 === f ? {} : f, g = f.getRoleAssignments, h = void 0 === g ? [] : g, i = e.error, !i) {
                  a.next = 9;
                  break;
                }

                return a.abrupt("return", {
                  error: i
                });

              case 9:
                return a.abrupt("return", {
                  collaborators: h
                });

              case 10:
              case "end":
                return a.stop();
            }
          }
        }, a);
      }));
      return function () {
        return a.apply(this, arguments);
      };
    }(), d.showCollaborationModal = function () {
      d.setState({
        collaborationModalVisible: !0,
        shareModalVisible: !1
      });
    }, d.hideCollaborationModal = function () {
      var a = d.state.members;
      d.setState({
        collaborationModalVisible: !1,
        draftMembers: a
      });
    }, d.showShareModal = function () {
      d.setState({
        shareModalVisible: !0,
        collaborationModalVisible: !1
      });
    }, d.hideShareModal = function () {
      var a = d.state.linkSharingSettings;
      d.setState({
        draftLinkSharingSettings: _objectSpread(_objectSpread({}, a), {}, {
          role: _objectSpread({}, a.role)
        }),
        shareModalVisible: !1
      });
    }, d.fetchCollaborationData = function () {
      var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
        var c, e, f, g, h, i, j, k, l, m, n, o, p, q;
        return _regenerator["default"].wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                return d.setState({
                  organisationId: b,
                  linkSharingSettings: void 0,
                  draftLinkSharingSettings: void 0,
                  roles: void 0,
                  guestRole: void 0
                }), c = d.props, e = c.resourceId, f = c.apiClient, a.next = 4, Promise.all([d.fetchResourceRoles(b), d.fetchRoleAssignments(e)]);

              case 4:
                if (g = a.sent, h = (0, _slicedToArray2["default"])(g, 2), i = h[0], j = i.error, k = i.roles, l = i.guestRole, m = h[1], n = m.error, o = m.collaborators, !(j || n)) {
                  a.next = 15;
                  break;
                }

                return a.abrupt("return");

              case 15:
                return a.next = 17, (0, _utils.getMembers)(o, b, f);

              case 17:
                p = a.sent, q = (0, _utils.getLinkSharingSettings)(o, l), d.setState({
                  draftMembers: (0, _lodash["default"])(p),
                  members: p,
                  roles: k,
                  guestRole: l,
                  deletedMembers: new Set(),
                  linkSharingSettings: q,
                  draftLinkSharingSettings: _objectSpread(_objectSpread({}, q), {}, {
                    role: _objectSpread({}, q.role)
                  })
                });

              case 20:
              case "end":
                return a.stop();
            }
          }
        }, a);
      }));
      return function () {
        return a.apply(this, arguments);
      };
    }(), d.onUpdateAndSaveMembers = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return b = d.state, c = b.draftMembers, e = b.deletedMembers, f = d.props, g = f.upsertRoleAssignments, h = f.deleteRoleAssignments, i = f.resourceId, j = f.resourceName, k = c ? c.map(function (a) {
                var b = a.resourceRoleAssignmentId,
                    c = a.userId,
                    d = a.teamId,
                    e = a.role.roleId;
                return {
                  resourceRoleAssignmentId: b,
                  userId: c,
                  teamId: d,
                  roleId: e
                };
              }) : [], l = e ? (0, _toConsumableArray2["default"])(e).map(function (a) {
                var b = a.resourceRoleAssignmentId;
                return b;
              }) : void 0, a.next = 6, Promise.all([g({
                assignments: k,
                resourceId: i,
                resourceType: j
              }), l ? h({
                assignmentIds: l,
                resourceId: i
              }) : Promise.resolve({})]);

            case 6:
              if (m = a.sent, n = (0, _slicedToArray2["default"])(m, 2), o = n[0], p = o.error, q = void 0 === p ? "" : p, r = o.data, r = void 0 === r ? {} : r, s = r.upsertRoleAssignments, t = n[1].error, u = void 0 === t ? "" : t, !(q || u)) {
                a.next = 16;
                break;
              }

              return a.abrupt("return");

            case 16:
              v = s.map(function (a, b) {
                var d = a.resourceRoleAssignmentId;
                return _objectSpread(_objectSpread({}, c[b]), {}, {
                  resourceRoleAssignmentId: d
                });
              }), d.setState({
                members: v,
                draftMembers: (0, _lodash["default"])(v)
              });

            case 18:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.onSaveLinkSharingSettings = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g, h, i, j, k, l, m, n, o, p;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return b = d.state, c = b.draftLinkSharingSettings, e = b.draftLinkSharingSettings, f = e.resourceRoleAssignmentId, g = e["public"], h = e.canSearch, i = e.organisation, j = e.role.roleId, k = d.props, l = k.upsertRoleAssignments, m = k.resourceId, n = k.resourceName, a.next = 4, l({
                assignments: [{
                  resourceRoleAssignmentId: f,
                  public: g,
                  canSearch: h,
                  roleId: j,
                  organisationId: i ? i.organisationId : null
                }],
                resourceId: m,
                resourceType: n
              });

            case 4:
              if (o = a.sent, p = o.error, !p) {
                a.next = 8;
                break;
              }

              return a.abrupt("return");

            case 8:
              d.setState({
                linkSharingSettings: _objectSpread({}, c),
                shareModalVisible: !1
              });

            case 9:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.onChangeLinkShareSettings = function (a) {
      d.setState(function (b) {
        var c = b.draftLinkSharingSettings;
        return {
          draftLinkSharingSettings: _objectSpread(_objectSpread({}, c || {}), a)
        };
      });
    }, d.onRemoveMember = function (a) {
      return function () {
        d.setState(function (b) {
          var c = b.draftMembers,
              d = void 0 === c ? [] : c,
              e = b.deletedMembers,
              f = void 0 === e ? new Set() : e,
              g = (0, _lodash["default"])(d),
              h = (0, _lodash["default"])(f);
          return h.add(d[a]), g.splice(a, 1), {
            draftMembers: g,
            deletedMembers: h
          };
        });
      };
    }, d.onUpdateMember = function (a, b) {
      d.setState(function (c) {
        var d = c.draftMembers,
            e = (0, _lodash["default"])(d);
        return e.splice(a, 1, b), {
          draftMembers: e
        };
      });
    }, d.onAddMember = function (a) {
      d.setState(function (b) {
        var c = b.draftMembers,
            d = b.guestRole,
            e = (0, _lodash["default"])(c);
        return e.push(_objectSpread(_objectSpread({}, a), {}, {
          role: d
        })), {
          draftMembers: e
        };
      });
    }, d.getUsers = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b,
          c,
          e,
          f,
          g,
          h,
          i,
          j,
          k = arguments;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return b = d.props, c = b.getUsersByName, e = b.apiClient, f = d.state.organisationId, a.next = 4, c.apply(void 0, k);

            case 4:
              if (g = a.sent, h = g.data, i = g.error, h && h.getUsersByName && !i) {
                a.next = 9;
                break;
              }

              return a.abrupt("return", {
                data: h,
                error: i
              });

            case 9:
              return a.next = 11, (0, _utils.resolveProfileImages)(h.getUsersByName, f, e);

            case 11:
              return j = a.sent, a.abrupt("return", {
                data: {
                  getUsersByName: j
                }
              });

            case 13:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.state = {}, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.children,
          c = a.getTeamsByName,
          d = a.resourceId,
          e = a.resourceName,
          f = a.shareUrl,
          g = this.state,
          h = g.draftMembers,
          i = void 0 === h ? [] : h,
          j = g.members,
          k = g.organisationId,
          l = g.collaborationModalVisible,
          m = g.shareModalVisible,
          n = g.draftLinkSharingSettings,
          o = g.roles,
          p = void 0 === o ? [] : o;
      return _react["default"].createElement(_CollaborationContext.CollaborationProvider, {
        value: this.getProviderValue(j, e)
      }, _react["default"].createElement(_react["default"].Fragment, null, b, _react["default"].createElement(_CollaborationModal["default"], {
        visible: l,
        members: i,
        organisationId: k,
        resourceId: d,
        roles: p,
        onClose: this.hideCollaborationModal,
        getUsersByName: this.getUsers,
        getTeamsByName: c,
        onUpdateAndSaveMembers: this.onUpdateAndSaveMembers,
        onRemoveMember: this.onRemoveMember,
        onUpdateMember: this.onUpdateMember,
        onAddMember: this.onAddMember
      }), n ? _react["default"].createElement(_ShareModal["default"], {
        onSaveLinkSharingSettings: this.onSaveLinkSharingSettings,
        onChangeLinkShareSettings: this.onChangeLinkShareSettings,
        organisationId: k,
        visible: m,
        roles: p,
        onClose: this.hideShareModal,
        resourceName: e,
        linkSharingSettings: n,
        shareUrl: f
      }) : null));
    }
  }]), b;
}(_react.Component);

exports["default"] = CollaborationProvider;